module.exports = __webpack_public_path__ + "media/images/flags/16/French-Southern-Territories-522f1735a73ab1c84d200aaaccbe4f70.png";